//frontend/src/components/SearchManagerRequests/Chat/utils/media.js

import { HOMESERVER } from "../matrixClient";

export function parseMxc(mxc) {
  if (!mxc || typeof mxc !== "string" || !mxc.startsWith("mxc://")) {
    return null;
  }
  const rest = mxc.slice("mxc://".length);
  const slash = rest.indexOf("/");
  if (slash < 0) return null;
  return { server: rest.slice(0, slash), mediaId: rest.slice(slash + 1) };
}

/**
 * Скачать медиа через /_matrix/client/v1/media/download и вернуть blob URL.
 * Кэш в памяти — чтобы не дёргать повторно.
 */
const _cache = new Map();

export async function fetchMediaBlobUrl({ mxc, accessToken, thumb = false }) {
  const p = parseMxc(mxc);
  if (!p) return null;

  const key = `${thumb ? "t" : "d"}|${p.server}|${p.mediaId}`;
  if (_cache.has(key)) return _cache.get(key);

  const base = thumb
    ? `${HOMESERVER}/_matrix/client/v1/media/thumbnail/${encodeURIComponent(
        p.server
      )}/${encodeURIComponent(p.mediaId)}?width=400&height=400&method=scale`
    : `${HOMESERVER}/_matrix/client/v1/media/download/${encodeURIComponent(
        p.server
      )}/${encodeURIComponent(p.mediaId)}?allow_redirect=true`;

  const res = await fetch(base, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) throw new Error(`media HTTP ${res.status}`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  _cache.set(key, url);
  return url;
}

export async function downloadMedia({ mxc, accessToken, filename }) {
  const p = parseMxc(mxc);
  if (!p) return;
  const url = `${HOMESERVER}/_matrix/client/v1/media/download/${encodeURIComponent(
    p.server
  )}/${encodeURIComponent(p.mediaId)}?allow_redirect=true`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const blob = await res.blob();
  const obj = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = obj;
  a.download = filename || p.mediaId;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(obj), 10_000);
}